import React from 'react'
import styled from 'styled-components'
import { MEDIUM, MONO, TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import Forbes from './assets/forbes.svg'
import Bbc from './assets/bbc.svg'
import Coindesk from './assets/coindesk.svg'
import TechCrunch from './assets/techcrunch.svg'
import YahooFinance from './assets/yahoofinance.svg'
import Decrypt from './assets/decrypt.svg'
import NormalizedForbes from './assets/normalized_forbes.svg'
import NormalizedBbc from './assets/normalized_bbc.svg'
import NormalizedCoindesk from './assets/normalized_coindesk.svg'
import NormalizedTechCrunch from './assets/normalized_techcrunch.svg'
import NormalizedYahooFinance from './assets/normalized_yahoofinance.svg'
import NormalizedDecrypt from './assets/normalized_decrypt.svg'
import Link from '~shared/Link'
import Display from '~shared/Display'

const UnstyledPress = (props) => (
    <div {...props}>
        <h6>As featured on</h6>
        <ul>
            <li $appear>
                {/* eslint-disable-next-line max-len */}
                <Link newTab href="https://www.forbes.com/sites/oluwaseunadeyanju/2020/06/19/how-decentralization-could-alleviate-data-biases-in-artificial-intelligence/">
                    <Display as="img" mobile="none" tablet="block" src={Forbes} alt="Forbes" />
                    <Display as="img" tablet="none" src={NormalizedForbes} alt="Forbes" />
                </Link>
            </li>
            <li $appear>
                <Link newTab href="https://techcrunch.com/2018/06/03/monetizing-computing-resources-on-the-blockchain/">
                    <Display as="img" mobile="none" tablet="block" src={TechCrunch} alt="TechCrunch" />
                    <Display as="img" tablet="none" src={NormalizedTechCrunch} alt="TechCrunch" />
                </Link>
            </li>
            <li $appear>
                <Link newTab href="https://podcasts.apple.com/gb/podcast/digital-planet/id73331490?i=1000493817432">
                    <Display as="img" mobile="none" tablet="block" src={Bbc} alt="BBC" />
                    <Display as="img" tablet="none" src={NormalizedBbc} alt="BBC" />
                </Link>
            </li>
            <li $appear>
                <Link newTab href="https://decrypt.co/33429/crypto-help-make-andrew-yang-data-dividend-project-reality">
                    <Display as="img" mobile="none" tablet="block" src={Decrypt} alt="Decrypt" />
                    <Display as="img" tablet="none" src={NormalizedDecrypt} alt="Decrypt" />
                </Link>
            </li>
            <li $appear>
                <Link newTab href="https://www.coindesk.com/data-ownership-software-lawsuits">
                    <Display as="img" mobile="none" tablet="block" src={Coindesk} alt="coindesk" />
                    <Display as="img" tablet="none" src={NormalizedCoindesk} alt="coindesk" />
                </Link>
            </li>
            <li $appear>
                <Link newTab href="https://finance.yahoo.com/news/unionbank-wwf-blockchain-help-local-140001862.html">
                    <Display as="img" mobile="none" tablet="block" src={YahooFinance} alt="Yahoo Finance" />
                    <Display as="img" tablet="none" src={NormalizedYahooFinance} alt="Yahoo Finance" />
                </Link>
            </li>
        </ul>
    </div>
)

const Press = styled(UnstyledPress)`
    margin: 0 auto;
    max-width: 344px;

    @media (min-width: ${TABLET}px) {
        max-width: none;
    }

    @media (min-width: ${DESKTOP}px) {
        max-width: 1160px;
    }

    h6 {
        color: inherit;
        font-family: ${MONO};
        font-size: 14px;
        font-weight: ${MEDIUM};
        letter-spacing: 0.14em;
        line-height: normal;
        margin: 0 0 16px;
        text-align: center;
        text-transform: uppercase;
    }

    ul {
        align-items: center;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: space-around;
        list-style: none;
        margin: 0;
        padding: 16px;
        row-gap: 16px;
    }

    a {
        display: block;
        margin: 0 auto;
        max-width: 100%;

        :hover {
            img {
                opacity: 0.8;
            }
        }

        :active,
        :focus {
            img {
                opacity: 0.6;
            }
        }
    }

    img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
    }

    @media (min-width: 348px) {
        /* 348px is a custom breakpoint. Here, we switch from 1 column to 2. Below that point
           space is too tight for multiple items per row. */

        ul {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    @media (min-width: ${TABLET}px) {
        ul {
            display: flex;
            height: 72px;
            justify-content: space-between;
            padding: 0 32px;
        }

        li {
            padding: 0 16px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ul {
            padding: 0 72px;
        }

        li {
            padding: 0;
        }
    }
`

export default Press
